import React from 'react'

const ArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31312 3.64645C6.50838 3.45118 6.82496 3.45118 7.02023 3.64645L11.0202 7.64645C11.2155 7.84171 11.2155 8.15829 11.0202 8.35355L7.02023 12.3536C6.82496 12.5488 6.50838 12.5488 6.31312 12.3536C6.11786 12.1583 6.11786 11.8417 6.31312 11.6464L9.95957 8L6.31312 4.35355C6.11786 4.15829 6.11786 3.84171 6.31312 3.64645Z" fill="#2B244C" />
    </svg>
  )
}

export default ArrowRight

